import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}

const MyComponent: TOC<Signature> = <template>
  <div class='field'>
    <@form.Dropdown
      @labelName='Antériorité inscription sur liste attente greffe'
      @propertyName='registrationTransplantWaitingList'
      as |dropdown|
    >
      <dropdown.Item
        @key='patient-not-concerned'
        @value='Patient non concerné'
      />
      <dropdown.Item
        @key='patient-registered'
        @value='Patient(e) est inscrit(e) sur liste d’attente de greffe depuis l’année précédente ou antérieurement'
      />
    </@form.Dropdown>
  </div>
  <div class='field'>
    <@form.Dropdown
      @labelName='Réalisation du bilan'
      @propertyName='assessmentRealisation'
      as |dropdown|
    >
      <dropdown.Item
        @key='patient-not-benefit'
        @value="Le ou la patient(e) n'en a pas bénéficié"
      />
      <dropdown.Item
        @key='patient-benefit'
        @value='Le ou la patient(e) en a bénéficié'
      />
    </@form.Dropdown>
  </div>
  <div class='field'>
    <@form.Dropdown
      @labelName='Résultat du bilan'
      @propertyName='assessmentResult'
      as |dropdown|
    >
      <dropdown.Item
        @key='patient-refuse-transplantation'
        @value='Le ou la patient(e) refuse la transplantation'
      />
      <dropdown.Item
        @key='patient-is-on-kidney-transplant-waiting-list'
        @value='Le ou la patient(e) est inscrit(e) sur liste d’attente de transplantation rénale'
      />
      <dropdown.Item
        @key='patient-definite-transplantation-contraindication'
        @value='Le ou la patient(e) présente une contre-indication définitive à la transplantation'
      />
      <dropdown.Item
        @key='patient-being-assessed'
        @value='Le ou la patient(e) est en cours d’évaluation'
      />
    </@form.Dropdown>
  </div>
</template>;
export default MyComponent;
